module.exports = __webpack_public_path__ + "static/media/pt-aigfutura-medium-webfont.5a1cae0d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pt-aigfutura-medium-webfont.eot
// module id = 98
// module chunks = 3